import { GlobalTemplate } from "./GlobalTemplate";
import type { GlobalTemplateProps } from "./GlobalTemplate.d";
import { renderGlobalComponent } from "./GlobalTemplate.utils";

export { GlobalTemplate, renderGlobalComponent };
export type { GlobalTemplateProps };
